import React, { useState } from 'react';
import { getConfig, serverUrl } from '../../../../serverUrl';
import { toast } from 'react-toastify';

const paymentMethods = [
    { value: '', label: 'Select method' },
    { value: 'mpesa', label: 'M-Pesa' },
    { value: 'bank_transfer', label: 'Bank Transfer' },
    { value: 'cash', label: 'Cash' },
    { value: 'cheque', label: 'Cheque' },
];

const EditTransactionModal = ({ tenant, onClose, onSave }) => {
    const [editedData, setEditedData] = useState({
        paid_amount: tenant?.paid_amount || '',
        transaction_id: tenant?.transaction_id || '',
        payment_method: tenant?.payment_method || '',
        id: tenant?.id || '',
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const config = getConfig();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const data = {
                payment_amount: editedData.paid_amount,
                payment_method: editedData.payment_method,
                transaction_id: editedData.transaction_id,
            }

            // Update the payment approval status
            await serverUrl.patch(
                `/landlord/payment-approvals/${editedData.id}/`, data, config);

            toast.success('Successfully updated the payment');
            // onSave(editedData);
            onClose();
            window.location.reload()
        } catch (error) {
            console.error('Failed to update transaction:', error);

            toast.error('Failed to update transaction. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4">
            <div className="bg-white shadow-lg rounded-lg w-full max-w-md">
                <div className="p-6">
                    <h2 className="mb-4 font-semibold text-xl">Edit Transaction Details</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <p className="block mb-2 font-bold text-gray-950 text-md" />
                            Amount Paid
                            <input
                                type="number"
                                name="paid_amount"
                                value={editedData.paid_amount}
                                onChange={handleChange}
                                className="mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                                required
                                min="0"
                                step="0.01"
                            />

                        </div>

                        <div className="mb-4">
                            <p className="block mb-2 font-bold text-gray-950 text-md" />
                            Transaction ID
                            <input
                                type="text"
                                name="transaction_id"
                                value={editedData.transaction_id}
                                onChange={handleChange}
                                className="mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                                required
                            />

                        </div>

                        <div className="mb-4">
                            <p className="block mb-2 font-bold text-gray-950 text-md" />
                            Payment Method
                            <select
                                name="payment_method"
                                value={editedData.payment_method}
                                onChange={handleChange}
                                className="mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                                required
                            >
                                {paymentMethods.map((method) => (
                                    <option key={method.value} value={method.value}>
                                        {method.label}
                                    </option>
                                ))}
                            </select>

                        </div>

                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                type="button"
                                onClick={onClose}
                                disabled={isSubmitting}
                                className="disabled:opacity-50 px-4 py-2 text-gray-600 hover:text-gray-800 transition"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="bg-blue-500 hover:bg-blue-600 disabled:opacity-50 px-4 py-2 rounded-md text-white transition disabled:cursor-not-allowed"
                            >
                                {isSubmitting ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditTransactionModal;